import { DARK_MODE_PROVIDER_LOGOS } from './darkModeProviderLogos';

export const generatePublicImagePathFallback = ({
  type,
  name,
  dark,
}: {
  type: string;
  name?: string;
  dark?: boolean;
}) => {
  const base_url = window.location.origin;
  let publicImagePath = '';
  let origin = '';
  if (
    base_url.split(':')[1] === '//localhost' &&
    base_url.split(':')[2] !== '6006'
  ) {
    origin += '/public/images';
  } else {
    origin += '/images';
  }

  switch (type) {
    case 'framework':
      publicImagePath = `${origin}/${type}/default.svg`;
      break;
    case 'resourceType': {
      const provider = name?.split('::')?.[0]?.toLowerCase();
      if (provider) {
        // Match the provider-logo dark-mode swap used in generatePublicImagePath.
        const resolvedProvider =
          (dark && DARK_MODE_PROVIDER_LOGOS[provider]) || provider;
        publicImagePath = `${origin}/provider/${resolvedProvider}.png`;
      }
      break;
    }
  }

  return publicImagePath;
};
